const initOffuscation = () => {
  const links = document.querySelectorAll('[data-redirect-go]');
  if(links){
    links.forEach((link) => {
      link.addEventListener('click', (e) => {
        const url = decodeURIComponent(window.atob(link.dataset.redirectGo));
        if ((e && (e.which == 2 || e.button == 4 )) || e.ctrlKey || (link.hasAttribute('target') && link.getAttribute('target') === '_blank') ) {
          window.open(url);
        }
        else{
          window.location.href = url;
        }
      });
    });
  }
}

export { initOffuscation }
